(() => {
  'use strict';

  const initializeWidget = (root) => {
    if (!root || root.dataset.initialized === 'true') {
      return;
    }

    root.dataset.initialized = 'true';

    const launcher = root.querySelector('.kw-launcher');
    const panel = root.querySelector('.kw-panel');
    const closeButton = root.querySelector('.kw-panel__close');

    const inquiries = root.querySelectorAll('.kw-inquiry');
    const input = root.querySelector('.kw-message-input');
    const sendButton = root.querySelector('.kw-send');

    const whatsappNumber = String(
      root.dataset.whatsappNumber || ''
    ).replace(/\D/g, '');


    /* =====================================================
       BASIC VALIDATION
       ===================================================== */

    const hasValidNumber = () => {
      return whatsappNumber.length >= 8;
    };


    /* =====================================================
       OPEN / CLOSE
       ===================================================== */

    const openPanel = () => {
      root.classList.add('is-open');

      launcher?.setAttribute('aria-expanded', 'true');
      panel?.setAttribute('aria-hidden', 'false');

      window.setTimeout(() => {
        input?.focus();
      }, 180);
    };


    const closePanel = () => {
      root.classList.remove('is-open');

      launcher?.setAttribute('aria-expanded', 'false');
      panel?.setAttribute('aria-hidden', 'true');
    };


    launcher?.addEventListener('click', () => {

      const isOpen = root.classList.contains('is-open');

      if (isOpen) {
        closePanel();
      } else {
        openPanel();
      }

    });


    closeButton?.addEventListener('click', closePanel);


    /* =====================================================
       WHATSAPP URL
       ===================================================== */

    const createWhatsAppUrl = (message) => {

      if (!hasValidNumber()) {
        console.warn(
          '[Kyudo WhatsApp Widget] Please add a valid WhatsApp number in the Theme Editor.'
        );

        return null;
      }

      const encodedMessage = encodeURIComponent(
        String(message || '').trim()
      );

      return `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    };


    const openWhatsApp = (message, customLink = '') => {

      const cleanedCustomLink = String(customLink || '').trim();

      const url = cleanedCustomLink
        ? cleanedCustomLink
        : createWhatsAppUrl(message);

      if (!url) {
        return;
      }

      window.open(
        url,
        '_blank',
        'noopener,noreferrer'
      );
    };


    /* =====================================================
       INQUIRY BUTTONS
       ===================================================== */

    inquiries.forEach((button) => {

      button.addEventListener('click', () => {

        const message = button.dataset.message || '';
        const customLink = button.dataset.customLink || '';

        openWhatsApp(message, customLink);

      });

    });


    /* =====================================================
       TYPED MESSAGE
       ===================================================== */

    const sendTypedMessage = () => {

      const message = input?.value.trim();

      if (!message) {
        input?.focus();
        return;
      }

      openWhatsApp(message);

      input.value = '';

    };


    sendButton?.addEventListener(
      'click',
      sendTypedMessage
    );


    input?.addEventListener(
      'keydown',
      (event) => {

        if (
          event.key === 'Enter' &&
          !event.shiftKey
        ) {

          event.preventDefault();

          sendTypedMessage();

        }

      }
    );


    /* =====================================================
       ESC CLOSE
       ===================================================== */

    document.addEventListener(
      'keydown',
      (event) => {

        if (
          event.key === 'Escape' &&
          root.classList.contains('is-open')
        ) {

          closePanel();

        }

      }
    );

  };


  /* =======================================================
     INITIALIZE EXISTING WIDGETS
     ======================================================= */

  const initializeAll = () => {

    document
      .querySelectorAll('.kw-widget')
      .forEach(initializeWidget);

  };


  initializeAll();


  /* =======================================================
     SHOPIFY THEME EDITOR SUPPORT
     ======================================================= */

  if (window.Shopify?.designMode) {

    document.addEventListener(
      'shopify:section:load',
      (event) => {

        const section = event.target;

        if (!section) {
          return;
        }

        const widget =
          section.querySelector('.kw-widget');

        if (widget) {
          initializeWidget(widget);
        }

      }
    );

  }


  /* =====================================================
   MOBILE WHATSAPP BUTTON + FLOATING ATC POSITION
   ===================================================== */

const updateWhatsAppPosition = () => {
  if (window.innerWidth > 749) return;

  const launcher = document.querySelector('.kw-launcher');
  const floatingAtc = document.querySelector('.kyudo-floating-atc');

  if (!launcher || !floatingAtc) return;

  const isVisible = floatingAtc.classList.contains('is-visible');
  const atcHeight = floatingAtc.offsetHeight;

  launcher.style.bottom = isVisible
    ? '130px'
    : '20px';
};

const observeFloatingAtc = () => {
  const floatingAtc = document.querySelector('.kyudo-floating-atc');

  if (!floatingAtc) return;

  const observer = new MutationObserver(updateWhatsAppPosition);

  observer.observe(floatingAtc, {
    attributes: true,
    attributeFilter: ['class']
  });

  const resizeObserver = new ResizeObserver(updateWhatsAppPosition);
  resizeObserver.observe(floatingAtc);

  updateWhatsAppPosition();
};

observeFloatingAtc();
window.addEventListener('resize', updateWhatsAppPosition);



})();